var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.40916C0 6.60548 0.400126 5.859 1.08595 5.45735L12 0L22.9141 5.45735C23.543 5.859 24 6.60548 24 7.40916V18.3704C24 19.6334 22.9716 20.6667 21.7143 20.6667H2.28568C1.02841 20.6667 0 19.6334 0 18.3704V7.40916ZM12 12.9167L21.1805 6.88889L12 2.29631L2.81952 6.88889L12 12.9167Z",
    fill: "#03A9F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.f1c4ea840709d988ed36d660eb8aec3f.svg";
export { ForwardRef as ReactComponent };